import React, { useState, useEffect, useContext } from 'react'
import ReactDOM from 'react-dom'

import { withStyles, makeStyles } from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Button from '@material-ui/core/Button'
import ArrowRightOutlinedIcon from '@material-ui/icons/ArrowRightOutlined'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ReplayIcon from '@material-ui/icons/Replay'
import Slider from '@material-ui/core/Slider'
import OfflineBoltIcon from '@material-ui/icons/OfflineBolt'
import Grow from '@material-ui/core/Grow'

import Checkbox from '@material-ui/core/Checkbox'
import ToggleOffOutlinedIcon from '@material-ui/icons/ToggleOffOutlined'
import ToggleOnOutlinedIcon from '@material-ui/icons/ToggleOnOutlined'
import styles from './lmp.module.css'

import { SeasonSlider } from './season'
// import { WinterSlider } from './winter'

// import './Interconnection.css'

const useStyles = makeStyles({
  root: {
    width: 150,
    color: '#c2c6cc',
    marginLeft: '20px',
  },
  btn: {
    boxShadow: 'none',
    color: '#a65e44',
    borderColor: '#a65e44',
    '&:hover': {
      backgroundColor: '#a65e441A',
      borderColor: '#a65e44',
      boxShadow: 'none',
    },
  },
})

function Interconnections(props) {
  const [screenHeight, setScreenHeight] = useState(228)
  const [screenHeightTxt, setScreenHeightTxt] = useState('228px')

  const [sliderLMP, setSliderLMP] = useState([30, 70])
  const [sliderLMP6, setSliderLMP6] = useState([30, 70])
  const [sliderLMP12, setSliderLMP12] = useState([30, 70])

  const [currentRange, setCurrentRange] = useState('3M')

  const classes = useStyles()

  useEffect(() => {
    if (window.innerHeight <= 850) {
      setScreenHeight(166)
      setScreenHeightTxt('200px')
    }
  }, [])

  const sliderLMPS = (event, newValue) => {
    setSliderLMP(newValue)
  }

  const sliderLMPS6 = (event, newValue) => {
    setSliderLMP6(newValue)
  }

  const sliderLMPS12 = (event, newValue) => {
    setSliderLMP12(newValue)
  }

  const generalHeatmap = (min, max, id) => {
    // console.log(id)
    const item = [...props.layerData]
    const dif = (max - min) / 6
    const colorScale = [
      [255, 0, 0],
      [255, 94, 0],
      [255, 162, 0],
      [255, 230, 0],
      [225, 255, 0],
      [174, 255, 0],
      [0, 255, 0],
    ]
    const busNum = [[min], [min + dif], [min + dif * 2], [min + dif * 3], [min + dif * 4], [min + dif * 5], [max]]
    // console.log(busNum)
    id.map((val) => {
      // console.log(item.find((obj) => obj.id == val.id))
      item
        .find((obj) => obj.id == val.id)
        .data.map((obj) => {
          if (!obj.heatmap && obj.heatmap == null) obj.specificDesign.color = [255, 255, 255, 20]
          if (obj.heatmap && obj.heatmap <= min) obj.specificDesign.color = colorScale[0]
          if (obj.heatmap && obj.heatmap > min && obj.heatmap <= busNum[1]) obj.specificDesign.color = colorScale[1]
          if (obj.heatmap && obj.heatmap > busNum[1] && obj.heatmap <= busNum[2])
            obj.specificDesign.color = colorScale[2]
          if (obj.heatmap && obj.heatmap > busNum[2] && obj.heatmap <= busNum[3])
            obj.specificDesign.color = colorScale[3]
          if (obj.heatmap && obj.heatmap > busNum[3] && obj.heatmap <= busNum[4])
            obj.specificDesign.color = colorScale[4]
          if (obj.heatmap && obj.heatmap > busNum[4] && obj.heatmap <= busNum[5])
            obj.specificDesign.color = colorScale[5]
          if (obj.heatmap && obj.heatmap >= busNum[5]) obj.specificDesign.color = colorScale[6]
        })
    })

    id.map((val) => {
      item.find((obj) => obj.id === val.id).data = item.find((obj) => obj.id == val.id).data
      item.find((obj) => obj.id === val.id).design.color = [255, 255, 255 * Math.random()]
    })

    props.setLayerData(item)
  }

  const showAllLayer = (name, season) => (event) => {
    const elems = document.getElementsByName('local_marginal_prices')
    for (var i = 0; i < elems.length; i++) {
      if (!event.target.checked && elems[i].checked) elems[i].click()
      if (event.target.checked && !elems[i].checked) elems[i].click()
    }
  }

  const hideAllLayer = () => {
    const elems = document.getElementsByName('local_marginal_prices')
    for (var i = 0; i < elems.length; i++) {
      if (elems[i].checked) elems[i].click()
    }
  }

  const toggleLayer = (id) => (event) => {
    let newArr = [...props.sidebarData]
    let newArr2 = [...props.layerData]
    newArr[props.layer].layers[0][props.clientName][currentRange].map((val) => {
      val.id === id ? (val.show = event.target.checked) : null
    })
    newArr2.find((obj) => obj.id === id).visible = event.target.checked
    props.setLayerData(newArr2)
    props.setSidebarData(newArr)
  }

  const changeSeason = (range) => {
    setCurrentRange(range)
    //console.log(document.getElementById('lmp-toggle'))
    if (document.getElementById('lmp-toggle').checked) document.getElementById('lmp-toggle').click()
    hideAllLayer()
    const elems = document.getElementsByClassName(styles['month-btn'])
    Object.keys(elems).map((val) => {
      elems[val].id === range
        ? (elems[val].style.backgroundColor = '#a65e44')
        : (elems[val].style.backgroundColor = '#9d9d9d')
    })
  }

  const expand = (layer) => {
    // const height=document.getElementById('lmp-container').style.height
    const height = document.getElementById('lmp-container').clientHeight
    if (height === 68) {
      document.getElementById('lmp-container').style.height = '430px'
      document.getElementById('lmp-arrow').style.transform = 'rotate(90deg)'
    }
    if (height === 428) {
      document.getElementById('lmp-container').style.height = '70px'
      document.getElementById('lmp-arrow').style.transform = 'rotate(0deg)'
    }
  }

  return (
    <Grow timeout={{ appear: 1000, enter: 1000, exit: 200 }} in={props.grow}>
      <div className="saavi-mc">
        <div className="ifr-title">
          <p className="ifr-title-txt" style={{ marginLeft: '6px' }}>
            {props.sidebarData[props.layer].title}
          </p>
        </div>
        <form className="form-container" action="">
          <div id="lmp-container" className={styles['menu-container']}>
            <div className={styles['date-btn-container']}>
              <div
                id="3M"
                className={styles['month-btn']}
                style={{ background: '#a65e44' }}
                onClick={() => changeSeason('3M')}
              >
                3M
              </div>
              <div
                id="6M"
                className={styles['month-btn']}
                style={{ background: '#9d9d9d' }}
                onClick={() => changeSeason('6M')}
              >
                6M
              </div>
              <div
                id="12M"
                className={styles['month-btn']}
                style={{ background: '#9d9d9d' }}
                onClick={() => changeSeason('12M')}
              >
                12M
              </div>
            </div>

            <div style={{ display: 'flex', height: '50px' }}>
              <ArrowRightOutlinedIcon id="lmp-arrow" className={styles['arrow']} onClick={() => expand()} />
              <label //name={layer.name}
                className="ifr-lines-title"
                onClick={() => expand()}
              >
                {'LMP Node Level ' + currentRange}
              </label>
              <FormControlLabel
                style={{ marginRight: '-10px' }}
                control={
                  <Checkbox
                    id="lmp-toggle"
                    color="default"
                    onChange={showAllLayer('local_marginal_prices' + currentRange)}
                    icon={<ToggleOffOutlinedIcon />}
                    checkedIcon={<ToggleOnOutlinedIcon style={{ color: '#a65e44' }} />}
                  />
                }
              />
            </div>

            <div className="ifr-sub-menu">
              {props.conLayers[0][props.clientName]['3M'].map((values) => (
                <div className="saavi-switch" key={values.value}>
                  <FormControlLabel
                    style={{ marginLeft: '15px', marginRight: '0px', alignSelf: 'center' }}
                    control={
                      <Checkbox
                        //className='lmp-checkbox'
                        // name={'local_marginal_prices'+currentRange}
                        name={'local_marginal_prices'}
                        size="small"
                        color="primary"
                        icon={<OfflineBoltIcon style={{ fontSize: '15px' }} />}
                        checkedIcon={<OfflineBoltIcon style={{ fontSize: '15px', color: values.color }} />}
                        onChange={toggleLayer('local_marginal_prices_' + values.value + '_' + currentRange)}
                        value={values.value}
                      />
                    }
                  />
                  <label className="ifr-switch-label">{values.label}</label>
                </div>
              ))}

              <div>
                {currentRange === '3M' ? (
                  <SeasonSlider
                    layers={props.conLayers[0][props.clientName][currentRange]}
                    classes={classes}
                    slider={sliderLMPS}
                    sliderValue={sliderLMP}
                    setSliderValue={setSliderLMP}
                    // step={0.01}
                    min={0}
                    max={400}
                    title={'USD/MWh'}
                    units={[]}
                    reset={[30, 70]}
                    heatmap={generalHeatmap}
                    onChangeAfter={() =>
                      generalHeatmap(sliderLMP[0], sliderLMP[1], props.conLayers[0][props.clientName][currentRange])
                    }
                  />
                ) : currentRange === '6M' ? (
                  <SeasonSlider
                    layers={props.conLayers[0][props.clientName][currentRange]}
                    classes={classes}
                    slider={sliderLMPS6}
                    sliderValue={sliderLMP6}
                    setSliderValue={setSliderLMP6}
                    // step={0.01}
                    min={0}
                    max={400}
                    title={'USD/MWh'}
                    units={[]}
                    reset={[30, 70]}
                    heatmap={generalHeatmap}
                    onChangeAfter={() =>
                      generalHeatmap(sliderLMP6[0], sliderLMP6[1], props.conLayers[0][props.clientName][currentRange])
                    }
                  />
                ) : (
                  <SeasonSlider
                    layers={props.conLayers[0][props.clientName][currentRange]}
                    classes={classes}
                    slider={sliderLMPS12}
                    sliderValue={sliderLMP12}
                    setSliderValue={setSliderLMP12}
                    // step={0.01}
                    min={0}
                    max={400}
                    title={'USD/MWh'}
                    units={[]}
                    reset={[30, 70]}
                    heatmap={generalHeatmap}
                    onChangeAfter={() =>
                      generalHeatmap(sliderLMP12[0], sliderLMP12[1], props.conLayers[0][props.clientName][currentRange])
                    }
                  />
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </Grow>
  )
}

export default Interconnections
